interface CheckoutCardProps {
    children: React.ReactNode;
    className?: string; // Additional custom classes for styling
}

const CheckoutCard: React.FC<CheckoutCardProps> = ({
    children,
    className = "",
}) => {
    return (
        <div className={`rounded-md border border-gray-200 bg-white ${className}`}>
            {/* Card Body */}
            <div className="p-4 border-gray-100 sm:p-6">
                <div className="space-y-6">{children}</div>
            </div>
        </div>
    );
};

export default CheckoutCard;